exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.image-wrapper{background-color:#fff;overflow:hidden;cursor:pointer}.image-wrapper img{display:block;width:auto;height:auto;max-width:100%;max-height:100%;margin:0 auto}.image-wrapper .edit-image{display:flex;justify-content:center;align-items:center;flex-direction:column;background:rgba(74,74,74,.5);position:sticky;bottom:0;height:0;width:100%;opacity:0;transition:height .25s ease!important}.image-wrapper .edit-image input{position:absolute;opacity:0;height:0;width:0;z-index:1}.image-wrapper .edit-image img{position:absolute;width:0;height:0;opacity:0;transition:opacity .3s ease}.image-wrapper:hover .edit-image{opacity:1;position:sticky}.image-wrapper:hover .edit-image .camera-icon{height:16px;width:21px}.image-wrapper:hover .edit-image input{height:100%;width:100%;cursor:pointer}.image-wrapper:hover .edit-image img{opacity:1}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ImageUploader/ImageUploader.scss
// module id = 1570
// module chunks = 0